import { PropsWithChildren } from 'react';
import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { FeatureFlagName } from 'utils/featureFlagging/featureFlags';

import { hasFeature } from './hasFeature';

function mapStateToProps(state: RootReducerStateT, ownProps: OwnProps) {
  return {
    hasFeature: hasFeature(state, ownProps.name),
  };
}

type OwnProps = PropsWithChildren<{
  name: FeatureFlagName;
}>;

type StateProps = ReturnType<typeof mapStateToProps>;
type PropsT = OwnProps & StateProps;

/** Render a component if the provided feature flag is enabled */
function IfFeatureFlagOnInner(props: PropsT) {
  return props.hasFeature ? <>{props.children}</> : null;
}

/** Render a component if the provided feature flag is disabled */
function IfFeatureFlagOffInner(props: PropsT) {
  return !props.hasFeature ? <>{props.children}</> : null;
}

/** @deprecated Use `useFeatureFlag` instead. */
export const IfFeatureFlagOn = connect(mapStateToProps)(IfFeatureFlagOnInner);

/** @deprecated Use `useFeatureFlag` instead. */
export const IfFeatureFlagOff = connect(mapStateToProps)(IfFeatureFlagOffInner);
